import React from "react";

export function SaveChip({ state }: { state: "idle" | "saving" | "saved" | "error" }) {
  if (state === "idle") return null;
  const map = {
    saving: { cls: "bg-amber-50 text-amber-700 ring-amber-200", label: "Saving…" },
    saved:  { cls: "bg-emerald-50 text-emerald-700 ring-emerald-200", label: "Saved ✓" },
    error:  { cls: "bg-rose-50 text-rose-700 ring-rose-200", label: "Error — retry" },
  } as const;
  const { cls, label } = map[state];
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${cls}`}>
      {label}
    </span>
  );
}